<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>Seneca</h1>
<h1 class="bk1">Fifty Letters of a Roman Stoic</h1>
<p class="bkau1">Translated with an introduction and commentary by Margaret Graver and A. A. Long</p>
<p class="bkpub">The University of Chicago Press    Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-seneca-0003.vue?412fa260